export const informationAfterSelectCountry = () => {
    const messages = window.checkoutMessages || {};

    const addBlockMessage = ($select) => {
        if ($select.length === 0) return;

        const msgId = '#' + $select.attr('id') + '_message';
        if (!jQuery(msgId).length) {
            $select.closest('.form-row').after('<div class="country-message" style="display:none;" id="' + $select.attr('id') + '_message"></div>');
        }
    }

    const updateMessage = ($select) => {
        if ($select.length === 0) return;

        const msgId = '#' + $select.attr('id') + '_message';
        const country = $select.val();
        const msg = messages[country.toUpperCase()] || '';
        jQuery(msgId).html(msg);
        if(msg) {
            jQuery(msgId).slideDown();
        }
    }

    const selectors = ['#billing_country', '#shipping_country'];

    jQuery(document.body).on('update_checkout', function(){
        selectors.forEach(selector => {
            const $select = jQuery(selector);
            const msgId = '#' + $select.attr('id') + '_message';
            jQuery(msgId).remove();
        });
    });

    jQuery(document.body).on('updated_checkout', function(){
        selectors.forEach(selector => {
            const $select = jQuery(selector);
            addBlockMessage($select);
            updateMessage($select);
        });
    });
};
